import cx from 'classnames';
import { format } from 'date-fns';

import classes from './BuildInfo.module.scss';

interface IBuildInfoProps {
  className?: string;
  versionOnly?: boolean;
}

const BuildInfo = ({ className, versionOnly }: IBuildInfoProps) => {
  const version = import.meta.env.PACKAGE_VERSION;
  const commitHash = import.meta.env.COMMIT_HASH;
  const shortCommitHash = commitHash ? commitHash.slice(0, 7) : commitHash;
  const buildTimestamp = import.meta.env.BUILD_TIMESTAMP;

  return (
    <p
      className={cx(classes.buildInfo, className)}
      title={`${version} • ${commitHash}`}
    >
      {version}
      {!versionOnly && (
        <>
          {' '}
          • {shortCommitHash}
          {buildTimestamp && <> • {format(new Date(buildTimestamp), 'PPp')}</>}
        </>
      )}
    </p>
  );
};

export default BuildInfo;
